export default __webpack_public_path__ + "static/media/Bianca.dd284fe6.jpg";